var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.showOverlay,"width":"80%"}},[_c('v-progress-circular',{attrs:{"width":7,"indeterminate":"","size":"64","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }